import { ArrowBigLeft, Blocks, Dog, Locate, Music, PawPrint, RatIcon, Send, Share, ShoppingBasket } from "lucide-react";

// HeroDesignerPure.jsx
export default function HeroCard13() {
  return (
    <>
      <section className="designer-hero" aria-labelledby="hero-title">

        {/* subtle radial gradients */}
        
        <div className="hero-inner">

          {/* LEFT: text / stats */}
          <div className="hero-left">
            <h2 id="hero-title" className="kicker">Let's Start</h2>
            <h1 className="hero-head">
              Practice Smart with Free Online Mock Tests
            </h1>

            <p className="hero-desc">
             Practice SSC GD Constable exams with chapter-wise, section-wise and full-length mock tests.
Start free. Upgrade only if you need more.
            </p>

            <ul className="stats" role="list" aria-hidden>
              <li><strong>1500+</strong><span>Completed Questions</span></li>
              <li><strong>6+</strong><span>Experts Team</span></li>
              <li><strong>12k+</strong><span>PDFs on Emails </span></li>
            </ul>

            <button className="btn-cta">Start Free Test</button>
          </div>

          {/* RIGHT: orbit-c12 + profile */}
          <div className="hero-right" aria-hidden>

          

            {/* center profile */}
            <div className="profile-wrap">
              <div className="profile-ring"></div>
              <div className="profile photo-shine">
                <img src="https://i.postimg.cc/HnccgbhF/5.png" alt="Designer portrait" />
              </div>
            {/* ORBIT 1 */}
<div className="orbit-c12-layer layer1">
  <div className="orbit-c12-ring"></div>
  <div className="orbit-c12-icon shine figma">
    <Send size={30} className="" />
  </div>
</div>

{/* ORBIT 2 */}
<div className="orbit-c12-layer layer2">
  <div className="orbit-c12-ring"></div>
  <div className="orbit-c12-icon shine xd">
     <ArrowBigLeft size={30} className="" />
  </div>
</div>

{/* ORBIT 3 */}
<div className="orbit-c12-layer layer3">
  <div className="orbit-c12-ring"></div>
  <div className="orbit-c12-icon shine ps">
     <Blocks size={30} className="" />
  </div>
</div>

{/* ORBIT 4 */}
<div className="orbit-c12-layer layer4">
  <div className="orbit-c12-ring"></div>
  <div className="orbit-c12-icon shine html">
     <Locate size={30} className="" />
  </div>
</div>

  </div>

          
            {/* small decorative dots */}
            <div className="dot dot-a" aria-hidden></div>
            <div className="dot dot-b" aria-hidden></div>

          </div>
        </div>

        <style>{`
        /* BASE ORBIT LAYER */
.orbit-c12-layer {
  position: absolute;
  left: 50%;
  top: 50%;
  transform-origin: center;
  pointer-events: none;
}

/* DOTTED ORBIT RINGS */
.orbit-c12-ring {
  position: absolute;
  inset: 0;
  border-radius: 50%;
  border: 2px dashed rgba(0,0,0,0.15);
  animation: ringPulse 6s ease-in-out infinite;
  opacity: .8;
}

/* ICON BASE STYLE */
.orbit-c12-icon {
  position: absolute;
  left: 50%;
  top: -38px;
  transform: translateX(-50%);
  width: 74px;
  height: 74px;
  background: #fff;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 
    0 12px 24px rgba(0,0,0,0.16),
    0 0 18px rgba(0,255,200,0.2);
  pointer-events: auto;
  overflow: hidden;
  animation:
    tilt 3s ease-in-out infinite alternate,
    pulse 4s ease-in-out infinite;
}

/* ICON IMAGE */
.orbit-c12-icon img {
  width: 48px;
  height: 48px;
  object-fit: contain;
}

/* GLOW TRAIL BEHIND ICON */
.orbit-c12-icon::before {
  content: "";
  position: absolute;
  width: 140%;
  height: 8px;
  left: -60%;
  top: 50%;
  transform: translateY(-50%);
  background: linear-gradient(90deg,
    rgba(0,255,200,0) 0%,
    rgba(0,255,200,0.35) 50%,
    rgba(0,255,200,0) 100%
  );
  filter: blur(8px);
  opacity: 0.8;
  animation: glowTrail 2.6s linear infinite;
}

/* SHINY SWEEP */
.shine::after {
  content: "";
  position: absolute;
  inset: -40% -40%;
  background: linear-gradient(110deg,
    rgba(255,255,255,0) 0%,
    rgba(255,255,255,0.3) 45%,
    rgba(255,255,255,0.8) 50%,
    rgba(255,255,255,0.3) 55%,
    rgba(255,255,255,0) 100%
  );
  animation: shineSweep 4s linear infinite;
  mix-blend-mode: screen;
}

/* DIFFERENT ORBIT DISTANCES + SPEEDS */
.layer1 {
  width: 260px; height: 260px;
  margin-left: -130px; margin-top: -130px;
  animation: orbit-c12CW 12s linear infinite;
}

.layer2 {
  width: 340px; height: 340px;
  margin-left: -170px; margin-top: -170px;
  animation: orbit-c12CCW 18s linear infinite;
}

.layer3 {
  width: 420px; height: 420px;
  margin-left: -210px; margin-top: -210px;
  animation: orbit-c12CW 26s linear infinite;
}

.layer4 {
  width: 500px; height: 500px;
  margin-left: -250px; margin-top: -250px;
  animation: orbit-c12CCW 34s linear infinite;
}

/* ANIMATIONS */
@keyframes orbit-c12CW {
  from { transform: translate(-50%, -50%) rotate(0deg); }
  to   { transform: translate(-50%, -50%) rotate(360deg); }
}

@keyframes orbit-c12CCW {
  from { transform: translate(-50%, -50%) rotate(360deg); }
  to   { transform: translate(-50%, -50%) rotate(0deg); }
}

@keyframes tilt {
  0% { transform: translateX(-50%) rotate(0deg); }
  50% { transform: translateX(-50%) rotate(4deg); }
  100% { transform: translateX(-50%) rotate(-3deg); }
}

@keyframes pulse {
  0% { transform: scale(0.98); }
  50% { transform: scale(1.06); }
  100% { transform: scale(0.98); }
}

@keyframes glowTrail {
  0% { transform: translateY(-50%) translateX(-60%); opacity:.2; }
  40% { opacity:.9; }
  100% { transform: translateY(-50%) translateX(60%); opacity:.2; }
}

@keyframes shineSweep {
  0% { transform: translateX(-140%) rotate(10deg); }
  40% { opacity:1; }
  100% { transform: translateX(140%) rotate(10deg); opacity:0; }
}

@keyframes ringPulse {
  0% { opacity: .7; transform: scale(1); }
  50% { opacity: 1; transform: scale(1.04); }
  100% { opacity: .7; transform: scale(1); }
}

/* =============== Designer Hero (PURE CSS) =============== */
.designer-hero {
  position: relative;
 
  padding: 72px 0 100px;
  background: transparent;
  font-family: Inter, system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial;
  color: #0b1320;
}

/* soft background gradients */
.bg-grad { position:absolute; border-radius:50%; filter: blur(60px); opacity:.45; pointer-events:none; z-index:0; }
.bg1 { width:520px; height:520px; left:-8%; top:-8%; background: radial-gradient(circle at 30% 30%, #e9f8f6 0%, transparent 45%); }
.bg2 { width:420px; height:420px; right:-6%; bottom:-4%; background: radial-gradient(circle at 70% 70%, #fff0f3 0%, transparent 45%); }

/* layout grid */
.hero-inner {
  width: 92%;
  max-width: 1240px;
  margin: 0 auto;
  display:grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  align-items:center;
  position:relative;
  z-index:5;
}

/* ---------- LEFT ---------- */
.hero-left { padding-left: 18px; }
.kicker { font-size:22px; font-weight:800; color:rgba(144, 202, 249,1); margin:0 0 6px; }
.hero-head { font-size:48px; margin:0 0 12px; font-weight:800; line-height:1.05; color: #13303a; }
.hero-desc { color:#6b7a81; max-width: 62%; margin-bottom:22px; font-size:15px; }

/* stats row */
.stats { list-style:none; padding:0; margin: 18px 0 28px; display:flex; gap:36px; align-items:flex-end; }
.stats li { display:flex; flex-direction:column; gap:6px; }
.stats strong { font-size:24px; font-weight:900; color:#0b1320; display:block; }
.stats span { color:#7e8b8f; font-size:13px; }

/* CTA */
.btn-cta {
  display:inline-block;
  background: linear-gradient(180deg,rgba(144, 202, 249,1) 0%, rgba(144, 202, 249,0.91) 100%);
  color:#fff;
  border:none;
  padding:12px 20px;
  border-radius:10px;
  font-weight:700;
  cursor:pointer;
  box-shadow: 0 12px 30px rgba(255,78,122,0.16);
  transition: transform .22s ease, box-shadow .22s ease;
}
.btn-cta:hover { transform: translateY(-4px); box-shadow: 0 20px 50px rgba(255,78,122,0.18); }

/* ---------- RIGHT (orbit-c12 + profile) ---------- */
.hero-right { position:relative; height: 520px; display:flex; align-items:center; justify-content:right; }

/* orbit-c12 svg (dashed ring) */
.orbit-c12 { position:absolute; width:420px; height:420px; z-index:2; left:50%; transform:translateX(-50%); top:40px; pointer-events:none; }
.orbit-c12 .orbit-c12-ring {
  stroke: rgba(12,20,28,0.18);
  stroke-width:3;
  stroke-dasharray:6 12;
  stroke-linecap:round;
  filter: drop-shadow(0 6px 12px rgba(0,0,0,0.06));
  fill:none;
  transform-origin:center;
  animation: orbit-c12Rotate 18s linear infinite;
}
.orbit-c12 .orbit-c12-dots circle { fill: rgba(18,26,34,0.12); }

/* profile center */
.profile-wrap { top:150px; position:relative; width:260px; height:260px; z-index:6; display:flex; align-items:center; justify-content:center; }
.profile-ring {
  position:absolute; inset:-18px; border-radius:50%; border:8px solid #fff; box-shadow: 0 20px 60px rgba(8,12,20,0.12);
  z-index:3;
}
.profile { width:220px; height:220px; border-radius:50%; overflow:hidden; background:rgba(144, 202, 249,1); display:flex; align-items:center; justify-content:center; z-index:4; position:relative; }
.profile img { width:100%; height:100%; object-fit:cover; display:block; }

/* autoplay shine sweep on profile (looping) */
.photo-shine::before {
  content: "";
  position: absolute;
  inset: -40% -40%;
  background: linear-gradient(110deg,
    rgba(255,255,255,0) 0%,
    rgba(255,255,255,0.28) 45%,
    rgba(255,255,255,0.7) 50%,
    rgba(255,255,255,0.28) 55%,
    rgba(255,255,255,0) 100%);
  transform: rotate(12deg) translateX(-120%);
  mix-blend-mode: screen;
  opacity: 1;
  animation: shineLoop 4.4s linear infinite;
  pointer-events:none;
}
@keyframes shineLoop {
  0% { transform: rotate(12deg) translateX(-130%); }
  20% { transform: rotate(12deg) translateX(-30%); opacity:0.9; }
  40% { transform: rotate(12deg) translateX(20%); opacity:0.6; }
  100% { transform: rotate(12deg) translateX(130%); opacity:0.0; }
}

/* icons floating around (glow + bob + slight rotation) */
.icon {
  position:absolute;
  width:72px;
  height:72px;
  border-radius:18px;
  background:#fff;
  display:flex;
  align-items:center;
  justify-content:center;
  box-shadow: 0 12px 32px rgba(4,8,16,0.12);
  z-index:7;
  overflow:hidden;
  transform-origin:center;
  animation: iconFloat 5.6s ease-in-out infinite;
}
.icon img { width:46px; height:46px; object-fit:contain; display:block; }

/* individual positions */
.icon-figma { left: calc(50% - 210px); top: 38%; transform: translate(-10%, -10%); animation-delay: 0.1s; }
.icon-xd    { left: calc(50% - 40px); top: 12%; transform: translate(-50%,-20%); animation-delay: 0.5s; }
.icon-ps    { left: calc(50% + 130px); top: 36%; transform: translate(-50%,-10%); animation-delay: 0.85s; }
.icon-html  { left: calc(50% + 120px); top: 66%; transform: translate(-50%,-60%); animation-delay: 1.1s; }

/* glow pulse for icons */
.icon::after {
  content: "";
  position:absolute;
  inset: -6px;
  border-radius: 18px;
  background: radial-gradient(circle, rgba(0,165,161,0.06), transparent 30%);
  z-index:-1;
  filter: blur(6px);
  animation: pulse 2.8s ease-in-out infinite;
}

/* decorative small dots */
.dot { position:absolute; width:8px; height:8px; border-radius:50%; background:#0ea99a; box-shadow: 0 6px 14px rgba(14,169,154,0.12); z-index:6; opacity:.9; }
.dot-a { left: 41%; top: 10%; }
.dot-b { left: 78%; top: 62%; }

/* ---------- ANIMATIONS ---------- */
@keyframes orbit-c12Rotate {
  from { transform: rotate(0deg); }
  to   { transform: rotate(360deg); }
}

@keyframes iconFloat {
  0% { transform: translateY(0) rotate(0.5deg) ; }
  50% { transform: translateY(-10px) rotate(-0.5deg); }
  100% { transform: translateY(0) rotate(0.5deg); }
}

@keyframes pulse {
  0% { transform: scale(0.96); opacity: 0.6; }
  50% { transform: scale(1.06); opacity: 0.95; }
  100% { transform: scale(0.96); opacity: 0.6; }
}

/* ---------- responsive ---------- */
@media (max-width: 980px) {
.bg-grad { position:absolute; border-radius:50%; filter: blur(60px); opacity:.45; pointer-events:none; z-index:0; }
.bg1 { width:260px; height:520px;  }
.bg2 { width:260px;  height:520px;  }
.designer-hero {
  position: relative;
 
  padding: 2px 0 10px;
  background: transparent;
  font-family: Inter, system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial;
  color: #0b1320;
}
  .hero-inner { grid-template-columns: 1fr; padding: 0px; gap: 28px; width:100%;  }
  .hero-left .hero-desc { max-width:100%; }
  .hero-right { height:420px; margin-top: 10px; display:flex; align-items:right; justify-content:right; }
  .orbit-c12 { width: 320px; height:320px; top:8px; }
  .profile-wrap { width:170px; height:170px; }
  .profile { width:170px; height:170px; }
  .icon { width:58px; height:58px; }
  .kicker { font-size:18px; }
  .hero-head { font-size:32px; }
  .stats { gap:20px; }
}

/* smaller phones */
@media (max-width: 520px) {
  .hero-head { font-size:26px; }
  .profile-wrap { display:block; margin: 10px auto; }
  .icon { display:none; }
  .orbit-c12 { display:none; }
  .dot { display:none; }
}
        `}</style>
      </section>
    </>
  );
}
